import React, { useEffect } from 'react';
import store from '../../redux/store';
import AllowCookiesStatus from '../../redux/modules/allowCookies/action';
import config from '../../config';

const CookieConsent = () => {
  const allowCookieAction = () => {
    window.cookieConsentDone && window.cookieConsentDone();
    store.dispatch(AllowCookiesStatus(window.allowCookie));
  };

  const allowCookieEvent = (e) => {
    allowCookieAction();
    console.log('cookieconsentdone by event trigger', e);
    document.removeEventListener(config.customEvent.cookieConsentDone, allowCookieEvent);
  };

  useEffect(() => {
    if (window.allowCookie) {
      console.log('cookieconsentdone by function trigger');
      allowCookieAction();
    } else {
      document.addEventListener(config.customEvent.cookieConsentDone, allowCookieEvent);
    }
  }, []);

  return '';
};

export default CookieConsent;
